// eslint-disable-next-line import/no-extraneous-dependencies
import { Carousel } from '@mantine/carousel';
import cs from 'classnames';
import type { EmblaCarouselType } from 'embla-carousel';
import type { FC } from 'react';
import { useEffect, useRef, useState } from 'react';
import type { IDateSelected } from '@/Module/Auth/Model/DataModel';
type DateTypes = 'year' | 'month' | 'day';
interface IDatepickerCarouselProps {
  type: DateTypes;
  items: number[];
  current?: number;
  onChange: (date: Partial<IDateSelected>) => void;
  title?: string;
}
const DatepickerCarousel: FC<IDatepickerCarouselProps> = ({
  title,
  type,
  items,
  current,
  onChange
}) => {
  const carouselRef = useRef<EmblaCarouselType>(null);
  const findIndex = items.findIndex(item => item === current);
  const [activeIndex, setActiveIndex] = useState(() => findIndex >= 0 ? findIndex : items[items.length - 1]);
  const handleSlideChange = (currentIndex: number) => {
    onChange({
      [type]: items[currentIndex]
    });
  };
  useEffect(() => {
    setActiveIndex(findIndex);
  }, [findIndex]);
  return <div className="flex flex-col" data-sentry-component="DatepickerCarousel" data-sentry-source-file="DatepickerCarousel.tsx">
      <div className="text-center font-semibold">{title}</div>
      <Carousel slideSize="33%" height={140} orientation="vertical" slideGap={0} withControls={false} skipSnaps getEmblaApi={ref => {
      // @ts-ignore
      carouselRef.current = ref;
    }} onSlideChange={handleSlideChange} initialSlide={activeIndex} data-sentry-element="Carousel" data-sentry-source-file="DatepickerCarousel.tsx">
        {items.map((item, index) => <Carousel.Slide key={item} className={cs(activeIndex === index ? 'text-xl text-blackSeven bg-white rounded-lg font-semibold' : 'text-xs text-onBackground ', 'transition-all duration-300 text-center  select-none flex items-center justify-center  min-w-[100px] max-h-[40px] cursor-pointer')}>
            {type === 'year' ? item : item.toString().padStart(2, '0')}
          </Carousel.Slide>)}
      </Carousel>
    </div>;
};
export default DatepickerCarousel;